// extracted by mini-css-extract-plugin
module.exports = {"specification-table":"specification-table-15186569dde14c27bf1c1663109134e6","goods-table-div":"goods-table-div-fd8e95743fed44aec654d752e8cbf43c"};